import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tryghedssamtale from './pages/services/Tryghedssamtale';
import HjaelpModSvindel from './pages/services/HjaelpModSvindel';
import TekniskHjaelp from './pages/services/TekniskHjaelp';
import PersonligHjaelp from './pages/services/PersonligHjaelp';
import Vidensbank from './pages/Vidensbank';
import VidensbankDetail from './pages/VidensbankDetail';
import Priser from './pages/Priser';
import Betingelser from './pages/Betingelser';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-blue-100 selection:text-blue-900 flex flex-col">
        <ScrollToTop />
        <Navbar />
        
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/tryghedssamtale" element={<Tryghedssamtale />} />
            <Route path="/services/hjaelp-mod-svindel" element={<HjaelpModSvindel />} />
            <Route path="/services/teknisk-hjaelp" element={<TekniskHjaelp />} />
            <Route path="/services/personlig-hjaelp" element={<PersonligHjaelp />} />
            <Route path="/vidensbank" element={<Vidensbank />} />
            <Route path="/vidensbank/:slug" element={<VidensbankDetail />} />
            <Route path="/priser" element={<Priser />} />
            <Route path="/betingelser" element={<Betingelser />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
